import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Button from 'components/atomic/Button';
import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 48px auto;
  position: relative;

  margin-right: ${theme.spaces.large / 2}px;
  margin-bottom: ${theme.spaces.regular}px;
  padding-left: ${theme.spaces.regular}px;
  padding-right: ${theme.spaces.regular}px;
  padding-top: ${theme.spaces.large4X}px;
  padding-bottom: ${theme.spaces.regular}px;

  border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
  border-radius: 8px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }

  > * {
    &:nth-child(1) {
      grid-row-start: 1;
      grid-row-end: 3;
    }

    &:nth-child(2) {
      grid-row-start: 1;
      grid-row-end: 2;
    }

    &:nth-child(3) {
      grid-row-start: 2;
      grid-row-end: 3;
    }
  }
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: ${theme.colors.gray.primary};

  svg {
    fill: ${theme.colors.white};
  }
`;

const StyledButtonContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;

const BankAccountsListItem = ({ id, title, text, onDelete, ...restProps }) => {
  const handleDelete = () => {
    onDelete && onDelete(id);
  };

  return (
    <StyledContainer {...restProps}>
      <StyledIconContainer>
        <Icon alias={ICON_ALIASES.dollarSquare} color={theme.colors.gray.primary} />
      </StyledIconContainer>
      <Text size={theme.fontSizes.small} weight={600}>
        {title}
      </Text>
      <Text size={theme.fontSizes.smallX} weight={500} color={theme.colors.gray.secondary}>
        {text}
      </Text>
      <StyledButtonContainer>
        <Button outlined color={theme.colors.red.primary} onClick={handleDelete}>
          Disconnect
        </Button>
      </StyledButtonContainer>
    </StyledContainer>
  );
};

BankAccountsListItem.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  onDelete: PropTypes.func,
};

export default BankAccountsListItem;
